export default {"src":"/apac/_next/static/media/periodic-table.1889fdca.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};